/*!
 * devextreme-angular
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

import { DxTemplateDirective } from './template';

export interface IDxTemplateHost {
  setTemplate: (template: DxTemplateDirective) => any;
}

export class DxTemplateHost {
  host: IDxTemplateHost;

  setHost(host: IDxTemplateHost) {
    this.host = host;
  }

  setTemplate(template: DxTemplateDirective) {
    this.host.setTemplate(template);
  }
}
